import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { PROGRAMS } from './constants';

const StepReview = ({ formData }) => {
  const program = PROGRAMS.find((p) => p.value === formData.program);
  return (
    <div className="form-step review-step">
      <h3><CheckCircle size={20} /> Review Your Information</h3>

      <div className="review-section">
        <h4>Player Information</h4>
        <p><strong>Name:</strong> {formData.player_first_name} {formData.player_last_name}</p>
        <p><strong>DOB:</strong> {formData.date_of_birth} (Age: {formData.age})</p>
        <p><strong>Gender:</strong> {formData.gender}</p>
        <p><strong>Program:</strong> {program?.label} - {formData.team_age_group}</p>
      </div>

      <div className="review-section">
        <h4>Parent/Guardian</h4>
        <p><strong>Name:</strong> {formData.parent_first_name} {formData.parent_last_name}</p>
        <p><strong>Email:</strong> {formData.email}</p>
        <p><strong>Phone:</strong> {formData.phone}</p>
        <p><strong>Address:</strong> {formData.address}, {formData.city}, {formData.state} {formData.zip_code}</p>
      </div>

      <div className="review-section">
        <h4>Emergency Contact</h4>
        <p><strong>Name:</strong> {formData.emergency_contact_name} ({formData.emergency_contact_relation})</p>
        <p><strong>Phone:</strong> {formData.emergency_contact_phone}</p>
      </div>

      <div className="review-section">
        <h4>Additional Details</h4>
        <p><strong>T-Shirt Size:</strong> {formData.tshirt_size}</p>
        {formData.discount_type && (
          <p><strong>Discount:</strong> {formData.discount_type === 'multi_child' ? 'Multi-Child (-$25)' : formData.discount_type}</p>
        )}
      </div>

      <div className="payment-notice">
        <AlertCircle size={20} />
        <p>
          This is an <strong>interest form</strong> — submitting will let a Panthers coordinator reach
          out to you. To officially register your child (and pay), please complete registration
          on the My Rec portal.
        </p>
      </div>
    </div>
  );
};

export default StepReview;
